/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener(
      "dispatch:cart-drawer:open",
      this.openDrawerViaEventHandler,
    );
    document.addEventListener(
      "dispatch:cart-drawer:close",
      this.closeDrawerViaEventHandler,
    );
    document.addEventListener(
      "dispatch:cart-drawer:refresh",
      this.cartRefreshHandler,
    );
    this.addEventListener("on:cart-drawer:before-open", () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
    });
    this.addEventListener("on:cart:after-merge", () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener(
      "dispatch:cart-drawer:refresh",
      this.cartRefreshHandler,
    );
    document.removeEventListener(
      "dispatch:cart-drawer:open",
      this.openDrawerViaEventHandler,
    );
    document.removeEventListener(
      "dispatch:cart-drawer:close",
      this.closeDrawerViaEventHandler,
    );
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector("cart-form").refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector("cart-form").refreshFromHtml(html);
  }
}

window.customElements.define("cart-drawer", CartDrawer);

document.addEventListener("DOMContentLoaded", function () {
  function initializeButtons() {
    var snapBuyNowBtn = document.querySelector(".snap_buy_now_btn");
    var addToCartBtn = document.querySelector(".add-to-cart");

    if (snapBuyNowBtn) {
      // Remove existing event listener if any
      snapBuyNowBtn.removeEventListener("click", handleSnapBuyNowClick);

      // Add new event listener
      snapBuyNowBtn.addEventListener("click", handleSnapBuyNowClick);
    }
  }

function handleSnapBuyNowClick() {
  const addToCartBtn = document.querySelector(".add-to-cart");
  const attachModules = window.attach_modules || [];

  if (addToCartBtn) {
    const handleCartAddSuccess = () => {
      // Disabled auto-open on add to cart
      // if (!attachModules || attachModules.length === 0) {
      //   document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
      // }
      // It's important to clean up listeners to avoid memory leaks
      document.removeEventListener('on:cart:add', handleCartAddSuccess);
      document.removeEventListener('on:cart:error', handleCartAddError);
    };

    const handleCartAddError = () => {
      // Clean up listeners on error as well
      document.removeEventListener('on:cart:add', handleCartAddSuccess);
      document.removeEventListener('on:cart:error', handleCartAddError);
    };

    document.addEventListener('on:cart:add', handleCartAddSuccess);
    document.addEventListener('on:cart:error', handleCartAddError);

    addToCartBtn.click();
  }
}

  // Initialize buttons on DOMContentLoaded
  initializeButtons();

  // Observe changes in the DOM to re-initialize buttons if needed
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        initializeButtons();
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
